import { Modal } from 'react-bootstrap';

type ModalCustomProps = {
  show: boolean;
  onHide: (listRefresh: boolean) => void;
  children: React.ReactNode;
  title: string | React.ReactNode;
  className?: string;
  paddingBody?: string;
  paddingHeader?: string;
  headerClassName?: string;
  dialogClassName?: string;
  size?: 'sm' | 'lg' | 'xl';
  backdrop?: 'static' | true | false; // Add backdrop control
};

const ModalCustom = ({
  children,
  show,
  onHide,
  title,
  className,
  paddingBody,
  paddingHeader,
  headerClassName,
  dialogClassName,
  size,
  backdrop = 'static' // Default to static (don't close on backdrop click)
}: ModalCustomProps) => {
  return (
    <Modal
      dialogClassName={dialogClassName}
      centered
      show={show}
      onHide={() => onHide(false)}
      className={className}
      backdrop={backdrop}
      keyboard={false} // Also prevent closing on ESC key
    >
      <Modal.Header
        style={{ padding: paddingHeader }}
        closeButton={typeof title === 'string'}
        className={headerClassName}
      >
        {typeof title === 'string' ? <Modal.Title>{title}</Modal.Title> : title}
      </Modal.Header>
      <Modal.Body style={{ padding: paddingBody }}>{children}</Modal.Body>
    </Modal>
  );
};

export default ModalCustom;
